import Konva from 'konva';

export class KonvaImage extends Konva.Image {
  private _lastSize: { width: number; height: number } | null = null;

  private _lastCrop: { x: number; y: number; width: number; height: number } | null = null;

  handleTransformStart() {
    this._lastSize = this.size();
    this._lastCrop = this.crop();
  }

  handleTransform(activeAnchor: string) {
    this.setAttrs({
      scaleX: 1,
      scaleY: 1,
      width: this.width() * this.scaleX(),
      height: this.height() * this.scaleY(),
    });

    if (this._lastSize && this._lastCrop) {
      this.handleCrop(this.size(), this._lastSize, this._lastCrop, activeAnchor);
    }
  }

  handleTransformEnd() {
    this._lastSize = null;
    this._lastCrop = null;
  }

  handleCrop(
    curSize: { width: number; height: number },
    lastSize: { width: number; height: number },
    lastCrop: { x: number; y: number; width: number; height: number },
    anchor: string
  ) {
    let ratio: number;
    let newCropWidth = lastCrop.width;
    let newCropHeight = lastCrop.height;
    const image = this.image() as HTMLImageElement;

    if (anchor === 'middle-left' || anchor === 'middle-right') {
      if (curSize.width < lastSize.width) {
        ratio = curSize.width / lastSize.width;
        newCropWidth = lastCrop.width * ratio;
        this.cropWidth(newCropWidth);
        if (anchor === 'middle-left') {
          this.cropX(lastCrop.x + lastCrop.width - newCropWidth);
        }
      } else {
        ratio = lastCrop.height / lastSize.height;
        newCropWidth = curSize.width * ratio;
        if (newCropWidth > image.width - lastCrop.x) {
          ratio = (image.width - lastCrop.x) / curSize.width;
          newCropHeight = curSize.height * ratio;
          this.cropHeight(newCropHeight);
        } else {
          this.cropWidth(newCropWidth);
        }
      }
    } else if (anchor === 'top-center' || anchor === 'bottom-center') {
      if (curSize.height < lastSize.height) {
        ratio = curSize.height / lastSize.height;
        newCropHeight = lastCrop.height * ratio;
        this.cropHeight(newCropHeight);
        if (anchor === 'top-center') {
          this.cropY(lastCrop.y + lastCrop.height - newCropHeight);
        }
      } else {
        ratio = lastCrop.width / lastSize.width;
        newCropHeight = curSize.height * ratio;
        if (newCropHeight > image.height - lastCrop.y) {
          ratio = (image.height - lastCrop.y) / curSize.height;
          newCropWidth = curSize.width * ratio;
          this.cropWidth(newCropWidth);
        } else {
          this.cropHeight(newCropHeight);
        }
      }
    }
  }
}
